let running = false;

export function setChatStreamRunning(value: boolean) {
  running = value;
}

export function isChatStreamRunning() {
  return running;
}
